import React, { ReactNode } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export interface LomavisDisabledElementOverlay1Props {
  /** The translated tooltip text to display */
  tooltipText: string;
  /** The element(s) to wrap with the tooltip */
  tooltipContent: ReactNode;
  /** Position of the tooltip - simplified to up or down */
  tooltipPosition?: 'up' | 'down';
  /** Whether the tooltip is disabled */
  disabled?: boolean;
}

/**
 * Atoms: LomavisDisabledElementOverlay1
 * 
 * A simple overlay component that wraps any element with a tooltip.
 * - Takes already translated tooltip text
 * - Simple up/down positioning
 * - Wraps any component or text with tooltip functionality
 * - Can be disabled conditionally
 * - Designed for disabled elements that need explanation tooltips
 */
export const LomavisDisabledElementOverlay1: React.FC<LomavisDisabledElementOverlay1Props> = ({
  tooltipText,
  tooltipContent,
  tooltipPosition = 'up',
  disabled = false
}) => {
  // If disabled, return content without tooltip
  if (disabled) {
    return <div>{tooltipContent}</div>;
  }

  // Map simple position to Bootstrap placement
  const placement = tooltipPosition === 'up' ? 'top' : 'bottom';

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip>{tooltipText}</Tooltip>
      }
    >
      {/* Ensure content is wrapped in a single element for OverlayTrigger */}
      <div>
        {tooltipContent}
      </div>
    </OverlayTrigger>
  );
};
